import { render, staticRenderFns } from "./AgendaRoute.vue?vue&type=template&id=4d008bc7"
import script from "./AgendaRoute.vue?vue&type=script&lang=js"
export * from "./AgendaRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports